import React from 'react'
import dateFormat from 'dateformat'
import TextField from '@material-ui/core/TextField'

import CheckBox from '../../../shared/checkBox'
import AutoComplete from '../../../shared/autoComplete'
import DatePicker from '../../../shared/form/datePicker'

export default {
    displayName: "Rate Card",
    idField: "rateCardID",

    getURL: id => "/rateCards?rateCardID=" + id,
    putURL: id => "/rateCard/" + id,
    deleteURL: id => "/rateCard/" + id,
    postURL: "/rateCard",
    getListURL: "/rateCards",
    maxWidth: "xs",
    recordName: formVals => {
        var dateBit = ""
        try {
            dateBit = " (" + dateFormat(new Date(formVals.fromDate), "dd/mm/yyyy") + ")"
        } catch (err) {
            //could not make a date
        }
        return formVals.name + dateBit
    },

    blankForm: {
        rateCardID: 0,
        name: "", 
        fromDate: dateFormat(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()), "yyyy-mm-dd") + "T00:00:00.000Z"
    },
    form : function (props) {
        function handleChange(event) {
            //merge it with the existing form vals and call the parent handler function
            props.onChange({...props.formVals, [event.target.id]: event.target.value})
        }

        //console.log("Date is " + props.formVals.fromDate.toString())
    
        return (
            <div>
                <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    label="Name"
                    type="text"
                    value={props.formVals.name}
                    onChange={handleChange}
                    error={props.validationResult.failMessages.hasOwnProperty("name")}
                    helperText={props.validationResult.failMessages["name"]}
                    fullWidth
                    disabled={props.disabled}
                />
                <DatePicker 
                    id="fromDate"
                    label="Effective from date"
                    onChange={handleChange}
                    value={props.formVals.fromDate}
                    error={props.validationResult.failMessages.hasOwnProperty("fromDate")}
                    helperText={props.validationResult.failMessages["fromDate"]}
                    disabled={props.disabled}
                />
    
            </div>
    
        )
    },
}

